/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ClockWidgetContainer_user$ref: FragmentReference;
declare export opaque type ClockWidgetContainer_user$fragmentType: ClockWidgetContainer_user$ref;
export type ClockWidgetContainer_user = {|
  +id: string,
  +$refType: ClockWidgetContainer_user$ref,
|};
export type ClockWidgetContainer_user$data = ClockWidgetContainer_user;
export type ClockWidgetContainer_user$key = {
  +$data?: ClockWidgetContainer_user$data,
  +$fragmentRefs: ClockWidgetContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ClockWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0b6e0b03a2b28a7a066b5b2a9250c30c';
module.exports = node;
